/**
 * Port of cdc-web `src/utils/oddsFormat/formatOddsMultiplier.ts`（1:1，注释保留原票号）。
 */

/**
 * Sentinel shown when a multiplier can't be computed. Matches the app-wide
 * "show `—` consistently for absent numbers" decision (OG-9666 spec §7,
 * Slack replies 76–88) and og-app `ODDS_MULTIPLIER_UNAVAILABLE`.
 */
export const ODDS_MULTIPLIER_UNAVAILABLE = '—'

/**
 * Payout multiple on a winning buy, derived FE-side from the implied
 * probability. Ported 1:1 from og-app `src/utils/format-odds-multiplier.ts`
 * to keep Web ↔ App parity.
 *
 * `chance` is the 0–100 implied probability the BE ships on the contract
 * (`chance` / `no_chance`) — NOT a 0–1 decimal. The multiplier is `100 / chance`:
 * e.g. chance 54 → 1.85x, chance 50 → 2.00x, chance 4 → 25.00x.
 *
 * Returns {@link ODDS_MULTIPLIER_UNAVAILABLE} for missing, empty, non-finite,
 * or out-of-range (`chance <= 0` or `chance > 100`) input rather than throwing,
 * so a locked / quote-less outcome renders a stable placeholder.
 */
export function formatOddsMultiplier(chance: string | number | null | undefined): string {
  if (chance === null || chance === undefined || chance === '') {
    return ODDS_MULTIPLIER_UNAVAILABLE
  }

  const num = Number(chance)
  if (!Number.isFinite(num) || num <= 0 || num > 100) {
    return ODDS_MULTIPLIER_UNAVAILABLE
  }

  const multiplier = 100 / num
  return `${multiplier.toFixed(2)}x`
}
